import gb3 from "../../../assets/Product_img/gb_III/1.jpeg";
import first from "../../../assets/Product_img/common/1.jpeg";
import second from "../../../assets/Product_img/common/2.jpeg";
import third from "../../../assets/Product_img/common/3.jpeg";
import four from "../../../assets/Product_img/common/4.jpeg";
import five from "../../../assets/Product_img/common/5.jpeg";

export const proLabGB3 = {
  hero: {
    title: "Pro-Lab ",
    title2:"GB III",
    description:
      "Designed for complex inert atmosphere workflows, delivering enhanced purification and workspace flexibility for demanding research applications.",
    imgUrl:
    gb3
  },

  productsDetails: {
    imgList: [
      gb3,first,second,third,four,five
    ],

    productName: "Pro-Lab GB III Glove Box",

    description:
      "The Pro-Lab GB III system provides a larger working environment, upgraded purification performance, and robust control systems tailored for advanced material science, energy research, and air-sensitive processes in R&D labs and pilot facilities.",

    keyFeatures: [
      "Enhanced oxygen & moisture stability (<2 ppm)",
      "Generous internal workspace for extended workflows",
      "Dual antechambers for efficient sample handling",
      "Advanced purification and pressure regulation",
      "Operator-focused ergonomics with premium visibility",
    ],

    download: {
      title: "Download Brochure PDF",
      downloadLink: "",
    },

    reviewList: [],
    descriptionTitle:"Product Description",

    briefDescirption:
      "Pro-Lab GB III strikes a balance between compact research gloveboxes and high-throughput systems. With expanded workspace, superior environmental control, and flexible usage options, it’s ideal for high-precision academic and industrial investigations.",
  },
};
